import React from 'react';
import 'tailwindcss/tailwind.css';
import { Route, Routes, BrowserRouter, Navigate } from 'react-router-dom';
import Navbar from './components/navbar';
//import Footer from './components/footer';
//import Landing from './components/pages/landing';
//import LoginPage from './components/pages/LoginPage';
import LoginPage from "./pages/LoginPage";
//import RegisterPage from './components/pages/register';
//import Home from './components/pages/Home';
import Privacy from './pages/privacy';
import Terms from './pages/terms';
//import GeneroConfig from './components/pages/administrador/GeneroConfig';
//import UserList from './components/pages/administrador/UsuariosConfig';
//import FilmeConfig from './components/pages/administrador/FilmeConfig';
//import SerieConfig from './components/pages/administrador/SerieConfig';
//import CapitulosConfig from './components/pages/administrador/CapitulosConfig';
//import CapituloView from './components/pages/CapituloView';
import UserProfile from './pages/PerfilUsuario';
import CommentSection from './pages/Comentarios';
import { jwtDecode } from "jwt-decode";
import AdminHome from './pages/Home';
import GestorUsuarios from './pages/administrador/UsuariosConfig';
import VideoShowConfig from './pages/administrador/VideoShowsConfig';
import ComediantesConfig from './pages/administrador/ComediantesConfig';
import UnderConstructionPage from './pages/UnderConstructionPage';
import LivestreamAdmin from './pages/administrador/LivestreamAdmin';
import LivestreamConfig from './pages/administrador/LivestreamConfig';
import LugaresEventoConfig from './pages/administrador/LugaresEventoConfig';
import EventoConfig from './pages/administrador/EventosConfig';
import ScannerPage from './pages/administrador/ScannerQR';
import Reportes from './pages/administrador/Reportes';

// Función auxiliar para verificar autenticación que podemos reutilizar
const isAuthenticated = () => {
  try {
    const token = localStorage.getItem("token");
    if (!token) return false;
    
    const decodedToken = jwtDecode(token);
    const currentTime = Date.now() / 1000;
    
    return !(decodedToken.exp && decodedToken.exp < currentTime);
  } catch (error) {
    console.error("Error verificando token:", error.message);
    return false;
  }
};

// Componente para rutas protegidas
const ProtectedRoute = ({ children }) => {
  return isAuthenticated() ? children : <Navigate to="/login" />;
};

// Nuevo componente para rutas públicas que redirige a usuarios autenticados
const PublicRoute = ({ children }) => {
  return !isAuthenticated() ? children : <Navigate to="/home" />;
};

// Componente para rutas protegidas específicas para administradores
const AdminRoute = ({ children }) => {
  const isAdmin = () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) return false;
      
      const decodedToken = jwtDecode(token);
      const currentTime = Date.now() / 1000;
      
      // Verificar si el token es válido y el usuario es administrador
      if (decodedToken.exp && decodedToken.exp < currentTime) return false;
      
      // Asumiendo que el rol está en decodedToken.role o similar
      return decodedToken.rol === "Administrador" || decodedToken.rol === "Comediante" || decodedToken.isAdmin === true;
    } catch (error) {
      console.error("Error verificando permisos de administrador:", error.message);
      return false;
    }
  };

  return isAdmin() ? children : <Navigate to="/home" />;
};

const App = () => {
  // Verificar autenticación al inicio
  React.useEffect(() => {
    const validateSession = () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) return;
        
        const decodedToken = jwtDecode(token);
        const currentTime = Date.now() / 1000;
        
        // Si el token está expirado, redirigir a login
        if (decodedToken.exp && decodedToken.exp < currentTime) {
          localStorage.removeItem("token");
          // Si estás usando algún estado global como Redux o Context, limpiar el estado aquí
        }
      } catch (error) {
        console.error("Error en validación de sesión:", error.message);
        localStorage.removeItem("token");
      }
    };

    validateSession();
  }, []);

  return (
    <div className="bg-black text-white min-h-screen flex flex-col">
      <BrowserRouter>
        <Navbar />
        <div className="flex-grow">
          <Routes>
            {/* Rutas públicas que redirigen a usuarios autenticados */}
            <Route path="/" element={
              <PublicRoute>
                <LoginPage />
                </PublicRoute>
            } />
            <Route path="/login" element={
              <PublicRoute>
                <LoginPage />
              </PublicRoute>
            } />
            {/*
            <Route path="/register" element={
              <PublicRoute>
                <RegisterPage />
              </PublicRoute>
            } />*/}
            
            {/* Rutas públicas que todos pueden ver */}
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            
            {/* Rutas protegidas que requieren autenticación */}
            <Route path="/home" element={
              <ProtectedRoute>
                <AdminHome />
              </ProtectedRoute>
            } />
            {/*}
            <Route path="/contenido/ver/:idCapitulo" element={
              <ProtectedRoute>
                <CapituloView />
              </ProtectedRoute>
            } />*/}
            <Route path="/Identity/Account/Manage" element={
              <ProtectedRoute>
                <UnderConstructionPage />
              </ProtectedRoute>
            } />
            <Route path="/comentarios" element={
              <ProtectedRoute>
                <UnderConstructionPage />
              </ProtectedRoute>
            } />
            
            {/* Rutas protegidas para administradores */}
            <Route path="/admin/usuario" element={
              <AdminRoute>
                <GestorUsuarios />
              </AdminRoute>
            } />
            <Route path="/admin/videoshows" element={
              <AdminRoute>
                <VideoShowConfig />
              </AdminRoute>
            } />
            <Route path="/admin/comediantes" element={
              <AdminRoute>
                <ComediantesConfig />
              </AdminRoute>
            } />
            <Route path="/admin/tags" element={
              <AdminRoute>
                <UnderConstructionPage />
              </AdminRoute>
            } />
            <Route path="/admin/entradas" element={
              <AdminRoute>
                <ScannerPage />
              </AdminRoute>
            } />
            <Route path="/admin/livestreams" element={
              <AdminRoute>
                <LivestreamConfig />
              </AdminRoute>
            } />
            <Route path="/admin/lugares" element={
              <AdminRoute>
                <LugaresEventoConfig />
              </AdminRoute>
            } />
            <Route path="/admin/eventos/" element={
              <AdminRoute>
                <EventoConfig />
              </AdminRoute>
            } />
            <Route path="/admin/reportes" element={
              <AdminRoute>
                <Reportes />
              </AdminRoute>
            } />

         
            
            {/* Ruta de error 404 - Redirige a la página principal */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
        {/*<Footer />*/}
      </BrowserRouter>
    </div>
  );
};

export default App;